import React from 'react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { SelectTeam } from '../coachingSummary/SelectTeam';
import { RevgenFilterProps } from './type';

export const RevgenFilter = ({
    date,
    userManagerLevel,
    selectTeamList,
    selectedTeam,        
    DateOnChange,
    handleReset,
    setSelectedTeam,
    setVisible,
    setSelectTeamList,
    parent,    
}: RevgenFilterProps) => {
    return (
        <div className="row mt-4">
                <div className="col-md-3">
                    <div className="content">
                        <label htmlFor="selectmonth">Month</label>
                        <Calendar
                            id="selectmonth"
                            value={date}
                            onChange={DateOnChange}
                            view="month"
                            maxDate={new Date()}
                            showIcon
                            className="custom-calendar"
                            dateFormat="MM, yy"
                        />
                    </div>
                </div>
                <div className="col-md-3">
                    <SelectTeam
                        selectTeamList={selectTeamList}
                        selectedTeam={selectedTeam}
                        setSelectedTeam={setSelectedTeam}
                        setVisible={setVisible}
                        setSelectTeamList={setSelectTeamList}
                        userManagerLevel={userManagerLevel}
                        revgenGoalTab
                        parent={parent}
                    />
                </div>
                <div className="col-md-3">
                    <Button
                        label="Reset"
                        style={{ fontWeight: 400, marginTop: '30px' }}
                        className="btn-secondary mb-2"
                        onClick={handleReset}
                    />
                </div>
            </div> 
    );
};
